import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import Hero from "@/pages/home/components/Hero";
import PromotionsSection from "@/pages/home/components/PromotionsSection";
import StorySection from "@/pages/home/components/StorySection";
import ClinicSection from "@/pages/home/components/ClinicSection";
import SkinSection from "@/pages/home/components/SkinSection";
import AcademySection from "@/pages/home/components/AcademySection";
import SupplySection from "@/pages/home/components/SupplySection";
import SocietySection from "@/pages/home/components/SocietySection";
import TipsSection from "@/pages/home/components/TipsSection";
import BeforeAfterSection from "@/pages/home/components/BeforeAfterSection";
import ContactBand from "@/pages/home/components/ContactBand";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero />
        <PromotionsSection />
        <StorySection />
        <ClinicSection />
        <SkinSection />
        <AcademySection />
        <SupplySection />
        <SocietySection />
        <TipsSection />
        <BeforeAfterSection />
        <ContactBand />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}